import uniqolor from "uniqolor";
import { TrackID } from "../types";
import { UNMATCHED_DETECTION_TRACK_ID } from "@/services/buffer-controller/utils";

const cache: Record<string, string> = {};

export function convertToHexChar(trackId: TrackID | number): string {
  if (typeof trackId === "string" && Number.isNaN(Number(trackId))) {
    return trackId;
  }

  if (cache[trackId]) {
    return cache[trackId];
  } else {
    const hex = String(trackId)
      .repeat(15)
      .replace(
        /./g,
        () =>
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[
            Math.floor(Math.random() * 62)
          ]
      );
    cache[trackId] = hex;

    return hex;
  }
}

type Some = Parameters<typeof uniqolor>;

export const memoize = (fn: any) => {
  const cache: Record<string, any> = {};
  return (...args: any[]) => {
    const n = args[0];
    if (n in cache) {
      return cache[n];
    } else {
      const result = fn(n);
      cache[n] = result;
      return result;
    }
  };
};

export const getUniqueColor = memoize(
  (trackId: TrackID | number, options?: Some[1]) => {
    if (trackId === UNMATCHED_DETECTION_TRACK_ID) {
      return {
        string: "rgb",
        array: [255, 0, 0, 0],
        isLight: false,
      };
    }

    const uniqueColor = uniqolor(
      Number(trackId) * 255 /* golden angle approximation */,
      {
        ...options,
        format: options?.format || "rgb",
        lightness: [45, 50],
        saturation: 80,
      }
    );
    const colorArray = [
      ...uniqueColor.color
        .replace("rgb", "")
        .replace("(", "")
        .replace(")", "")
        .split(",")
        .map((c) => Number(c.trim())),
      255,
    ] as [number, number, number, number];
    return {
      string: uniqueColor.color,
      array: colorArray,
      isLight: uniqueColor.isLight,
    };
  }
);
